export { RecentSearches } from "./RecentSearches";
